
export default function PlatformSection() {
  const features = [
    {
      icon: 'ri-smartphone-line',
      title: 'Multiplataforma',
      description: 'Accede desde tu computadora, tablet o teléfono. Tu progreso se sincroniza automáticamente en todos tus dispositivos.'
    },
    {
      icon: 'ri-cloud-line',
      title: 'Contenido en la nube',
      description: 'Todo tu contenido siempre disponible. Descarga las sesiones para acceder sin conexión cuando lo necesites.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Progreso adaptativo',
      description: 'El sistema se adapta a tu ritmo y necesidades, creando un plan personalizado que evoluciona contigo.'
    },
    {
      icon: 'ri-global-line',
      title: 'Comunidad global',
      description: 'Conéctate con personas de todo el mundo que comparten tu camino de transformación.'
    }
  ];

  return (
    <section className="py-32 bg-white">
      <div className="container mx-auto px-8">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-light text-gray-900 mb-8 tracking-tight">
            Transforma tu vida
            <span className="block font-thin bg-gradient-to-r from-[#6607a5] to-purple-600 bg-clip-text text-transparent">
              desde cualquier lugar
            </span>
          </h2>
          <p className="text-2xl text-gray-600 max-w-4xl mx-auto leading-relaxed font-light">
            Accede a todo el contenido desde cualquier dispositivo, en cualquier momento y lugar
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Platform Image */}
          <div className="relative">
            <div className="relative bg-gradient-to-br from-purple-50 to-purple-100 rounded-3xl p-12 shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/eeb6f71c46431ac1fde6cad29ff61ccd/b7656fa3745fc00952c52137a017257d.png"
                alt="NEO en múltiples dispositivos"
                className="w-full h-auto object-cover object-top rounded-2xl shadow-xl"
              />
              
              {/* Floating Elements */}
              <div className="absolute -top-4 -right-6 bg-white rounded-2xl p-4 shadow-xl border border-gray-100 transform rotate-6">
                <div className="flex items-center space-x-3">
                  <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse"></div>
                  <span className="text-sm font-medium text-gray-700">Sincronizado</span>
                </div>
              </div>
              
              <div className="absolute -bottom-4 -left-6 bg-white rounded-2xl p-4 shadow-xl border border-gray-100 transform -rotate-3">
                <div className="flex items-center space-x-3">
                  <i className="ri-download-cloud-line text-[#6607a5] text-lg"></i>
                  <span className="text-sm font-medium text-gray-700">Offline Ready</span>
                </div>
              </div>
            </div>
          </div>

          {/* Features */}
          <div className="space-y-10">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start space-x-6 group">
                <div className="w-16 h-16 bg-gradient-to-br from-[#6607a5] to-purple-600 rounded-2xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <i className={`${feature.icon} text-2xl text-white`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-medium text-gray-900 mb-3">{feature.title}</h3>
                  <p className="text-gray-600 font-light leading-relaxed text-lg">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
